import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import Icon from 'flarum/common/components/Icon';

app.initializers.add('local-warning-labels', () => {
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const post = this.attrs.post;

    const reasons = [];

    if (post.attribute('hasReportWarning')) {
      reasons.push('複数の通報を受けています');
    }

    if (post.attribute('hasNgwordWarning')) {
      reasons.push('不適切な可能性のある内容が含まれています');
    }

    if (reasons.length === 0) {
      return;
    }

    items.add(
      'warningLabel',
      <div className="WarningLabel">
        <Icon name="fas fa-triangle-exclamation" className="WarningLabel-icon" />
        <span className="WarningLabel-text">{reasons.join(' / ')}</span>
      </div>,
      -100
    );
  });
});
